import Toast from 'components/atoms/Toast'
import { SendPatientStatementsResult } from 'store/types'

const MAX_LISTED = 5

// One toast for what went, one for what did not — naming who and why, since a
// skipped statement is work the biller still has to finish by other means.
export const reportSendResult = (result: SendPatientStatementsResult) => {
  if (result.sent) {
    Toast({ type: 'success', label: `${result.sent} statement(s) sent` })
  }

  if (!result.skipped.length) {
    return
  }

  const lines = result.skipped
    .slice(0, MAX_LISTED)
    .map((skip) => `${skip.patientName || `#${skip.patientId ?? '?'}`}: ${skip.reasons.join('; ')}`)
  const more =
    result.skipped.length > MAX_LISTED ? ` …and ${result.skipped.length - MAX_LISTED} more` : ''

  Toast({
    type: result.sent ? 'warning' : 'error',
    label: `${result.skipped.length} statement(s) skipped — ${lines.join(' | ')}${more}`,
    options: { autoClose: false },
  })
}
